import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const options = {
    autoClose: 5000,
    hideProgressBar: false,
    newestOnTop: false,
    closeOnClick: true,
    rtl: false,
    pauseOnFocusLoss: true,
    draggable: true,
    pauseOnHover: true
};

export const toaster = (message,type='error') => {
    let temp = type;
    const isValidInfo = (type ==='Info');
    const isValidWarning = (type === 'Warning');
    const isValidSuccess = (type === 'Success');
    
    if (isValidInfo || isValidWarning || isValidSuccess) {
        type = temp;
    } else {
        type = 'error';    
    }
   
    toast(<span className="toastMsg">{message}</span>, {
        ...options,
        type: type,
    });
}
   